<div class="layout-sidebar">
    <div class="layout-menu-container h-full">
        <ul class="layout-menu">
            @for (group of groups; track group) {
                <li class="layout-root-menuitem">
                    <div class="layout-menuitem-root-text text-secondary">
                        <span>{{ group }}</span>
                    </div>
                    <ul>
                        @for (item of (itemsByGroup().get(group) ?? []); track item.routerLink) {
                            <li>
                                <a [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }" pRipple>
                                    <i class="layout-menuitem-icon" [ngClass]="item.icon"></i>
                                    <span class="layout-menuitem-text">{{ item.label }}</span>
                                    @if (badgeFor(item) !== undefined && badgeFor(item) !== null) {
                                        <span class="ml-auto">
                                            <p-badge [value]="badgeFor(item)"></p-badge>
                                        </span>
                                    }
                                </a>
                            </li>
                        }
                    </ul>
                </li>
            }
        </ul>
    </div>
</div>

